import React, { FC, useCallback, useState } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { Button, IconNav, Overlay } from '@wmgtech/legato'
import { Link } from 'react-router-dom'

import { HeaderMenuProps } from './HeaderMenu.props'
import './HeaderMenu.scss'

const HeaderMenu: FC<HeaderMenuProps> = ({ children }) => {
  const { oktaAuth } = useOktaAuth()
  const [isOpen, setIsOpen] = useState(false)
  const onLogout = useCallback(async () => oktaAuth.signOut(), [oktaAuth])

  return (
    <Overlay
      open={isOpen}
      onOpenChange={setIsOpen}
      trigger={
        <IconNav
          isActive={isOpen}
          className="header-menu__icon-button"
          icon="bars"
        />
      }
      placement="bottom-end"
      showFang={false}
    >
      <a
        href="https://wmg.sharepoint.com/sites/Storybox"
        target="_blank"
        className="header-menu__item"
        rel="noreferrer"
      >
        Help Center
      </a>
      <Link key={2} className="header-menu__item" to="/notifications/settings">
        Settings
      </Link>
      <Button
        key={3}
        className="header-menu__item header-menu__btn"
        onClick={onLogout}
        icon="fa-regular fa-arrow-right-from-bracket"
        size="md"
        colorType="secondary-white"
      >
        Logout
      </Button>
    </Overlay>
  )
}

export default HeaderMenu
